
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/ui/page-header';
import { useEffect } from 'react';
import { ResponsiveContainer } from '@/components/ResponsiveContainer';

const Welcome = () => {
  const navigate = useNavigate();
  const { authenticated, user } = useAuth();

  useEffect(() => {
    // Redirect authenticated users to appropriate page based on onboarding status
    if (authenticated && user) {
      switch (user.onboardingStatus) {
        case 'registration':
          navigate('/profile');
          break;
        case 'profile':
          navigate('/module');
          break;
        case 'survey':
          navigate('/module');
          break;
        case 'coaching':
        case 'completed':
          navigate('/updates');
          break;
        default:
          break;
      }
    }
  }, [authenticated, user, navigate]);

  return (
    <div className="min-h-screen bg-white pb-20 safe-area-inset">
      <PageHeader 
        title="KAMco"
        variant="title-only"
      />

      {/* Main Content */}
      <ResponsiveContainer maxWidth="2xl" className="flex-1 flex flex-col justify-start pt-8 sm:pt-16 md:pt-24">
        <div className="mb-8">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-black mb-6 leading-tight">
            Change is hard
          </h2>
          <p className="text-lg sm:text-xl lg:text-2xl text-[#666666] mb-6 leading-relaxed">
            KAMco makes organizational change better by improving communication across your team.
          </p>
          <p className="text-lg sm:text-xl lg:text-2xl text-[#666666] mb-8 leading-relaxed">
            Create your profile to join in the conversation.
          </p>
        </div>

        <div className="space-y-4 lg:max-w-md">
          <Button 
            onClick={() => navigate('/register')}
            className="w-full bg-black text-white hover:bg-[#666666] h-12 sm:h-14 rounded-lg text-base sm:text-lg font-medium min-touch-target touch-manipulation transition-colors"
          >
            Create profile
          </Button>
          
          <div className="text-center">
            <p className="text-sm sm:text-base lg:text-lg text-[#666666]">
              Already have an account?{' '}
              <button
                onClick={() => navigate('/login')}
                className="text-black font-medium hover:underline transition-all"
              >
                Sign in
              </button>
            </p>
          </div>
        </div>
      </ResponsiveContainer>
    </div>
  );
};

export default Welcome;
